@use '../../styling/colors.scss' as *;

.Separator {
  background-color: $color-action-text-dark;
  border-radius: 5px;
  height: 0.2em;
  width: 100%;
}

.Wrapper {
  display: grid;
  gap: 0.5em;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  svg {
    transform: rotate(90deg);
  }
}
